<template>
  <div class="components_warp">
    <div class="top-container">
          <div >
            <div>
              <div class="text_bewrite2">
                <p>
                  请阅读以下3句描述，判断这些描述与你自身情况的符合程度，并对3句据描述进行符合程度对比，标记在后面的选项上，注意一句描述只能对应一个符合程度选项，且不同描述对应不同选项。你可先选出完全符合的描述或完全不符合的描述并作标记，然后补全其他描述与选项的对应。
                </p>
              </div>
              <div class="table">
                <div v-for="(topic, index) in topics" :key="index">
                  <div  class="" v-if="index == curIndex">
                    <table id="customers">
                      <tr>
                        <th style="text-align: center">描述</th>
                        <th style="text-align: center">完全符合</th>
                        <th style="text-align: center">一般符合</th>
                        <th style="text-align: center">完全不符合</th>
                      </tr>
                      <tr v-for="(items, index2) in topic" :key="index2">
                        <td>{{items.topic}}</td>
                        <td v-for="(item,index3) in 3" :key="index3">
                          <section class="light">
                            <label>
                              <input
                                  class="radio_btn"
                                  type="radio"
                                  :value="listArr[index3]"
                                  v-model="radioVal[index2]" @click="compare(listArr[index3],index2)"/>
                              <span class="design"></span>
                              <span class="text"></span>
                            </label>
                          </section>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_warp">
          <span></span>
          <button @click="next">确定</button>
          <span
          ><em>{{ curIndex + 1 }}</em
          >/{{ topics.length }}</span
          >
        </div>
  </div>
</template>

<script>
export default {
name: "ques11",
  data() {
    return {
      curIndex: 0,
      topics: [],
      radioVal:["","",""],
      answers: [],
      tempTime: "",
      order: "",
      letterArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
      listArr:["A","B","C"],
	    url:{path:'/careerevalution/navigation',query: { part:'3'}},
      startTime: "",
    };
  },
  created() {
    this.getTopicApi();

  },
  methods: {
    getTopicApi() {
      this.$ajax
          .post(
              `${this.G_capi}${this.ports.careerEvaluation.xqqx.xqqxList1}`,
              {},
              {
                headers: {
                  token: sessionStorage.getItem("token"),
                },
              }
          )
          .then((res) => {
            this.topics = res.data.data;
            this.startTime = new Date().getTime();
          });
    },
    next() {
      if(!this.radioVal[0]||!this.radioVal[1]||!this.radioVal[2]){
        this.$message.error('请选择答案')
        return;
      }
      this.tempTime = new Date().getTime();
      let arr=[]
      this.topics[this.curIndex].forEach((item,index)=>{
        arr.push({
          questionId:item.id,
          order: item.order,
          answer:this.radioVal[index]
        })
      })
      this.answers.push(arr)
      this.radioVal = ["","",""];
      if (this.curIndex + 1 < this.topics.length) {
        this.curIndex++;
      } else {
        this.saveNode(4,11,()=>{
          this.submit()
        })
      }
    },
    compare(item){
      if(this.radioVal.indexOf(item)>=0){
        this.radioVal[this.radioVal.indexOf(item)]=""
      }
    },
    submit() {
      //提交
      this.$ajax
          .post(
              `${this.G_capi}${this.ports.careerEvaluation.xqqx.xqqxAdd}`,
              {
                testId: sessionStorage.getItem("testId"),
                time: this.tempTime-this.startTime,
                answers: this.answers,
              },
              {
                headers: {
                  token: sessionStorage.getItem("token"),
                },
              }
          )
          .then((res) => {
            var data = res.data;
            if(data.code==2000){
              this.$router.push({
                path: "/careerevalution/success",
                query: {
                  type: "answer",
                  url:this.url,
                  part:true
                },
              });
            }
          });
    },
  },
}
</script>

<style scoped>
.components_warp{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.title h4 {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.text_bewrite2 p {
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
}
.btn_warp {
  /* width: 70%;
    text-align: center;
    position: absolute;
    bottom:70px; */
  display: flex;
  justify-content: space-between;
}

/* 按钮 */
.btn_warp button {
  width: 166px;
  height: 41px;
  background: linear-gradient(90deg, #1fd99c 0%, #1ac6fd 100%);
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: 40px auto 0;
  display: block;
}

.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;
}

.table {
  margin-top: 30px;
}
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  width: 100%;
  border-collapse: collapse;
}
#customers td,
#customers th {
  font-size: 1em;
  border: 1px solid #979797;
  padding: 3px 7px 2px 7px;
  color: #000;
  background-color: #f8f8f8;
}
#customers th {
  font-size: 1.1em;
  text-align: left;
  padding-top: 5px;
  padding-bottom: 4px;
  background-color: #f8f8f8;
  color: #000;
}

/* 单选按钮 */

.light {
  --primary: #29d3ec;
  --other: #29d3ec;
  display: flex;
  justify-content: center;
}

.dark {
  --primary: hsl(1, 100%, 68%);
  --other: hsl(0, 0%, 90%);
  background: hsl(0, 0%, 10%);
}

/* h1 */
h1 {
  color: var(--other);
  padding: 8px 4px;
  border-bottom: 2px solid var(--other);
}

/* label */
label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  margin: 12px 0;
  height: 20px;
  background: hsl(0, 0%, 98%);
  cursor: pointer;
  position: relative;
  border-radius: 8px;
  /* padding: 0 15px; */
}

/* input */
.radio_btn {
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: -1;
}

/* .design */
.design {
  width: 16px;
  height: 16px;
  border: 1px solid var(--other);
  border-radius: 100%;
  /* margin-right: 16px; */
  position: relative;
}

.design::before,
.design::after {
  content: "";
  display: block;

  width: inherit;
  height: inherit;

  border-radius: inherit;

  position: absolute;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.design:before {
  background: var(--other);
  opacity: 0;
  transition: 0.3s;
}

.design::after {
  background: var(--primary);
  opacity: 0.4;
  transition: 0.6s;
}

/* .text */
.text {
  color: #333;
  /* font-weight: bold; */
}

/* checked state */
.radio_btn:checked + .design::before {
  opacity: 1;
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}
</style>